
let url = window.location.href;
let URLConstants = {
    BASE_URL: "",
    ATTENDANCE_BASE_URL: "",
    ALFRESCO_BASE_URL: "",
    IMAGE_BASE_URL: "",
    BASE_URL_EXPORT: "",
    DOWNLOAD_URL: "",
    UPLOAD_FILE_URL: "",
    COMPANY_IMG_URL: "",

    LOGIN_URL: "",
    WEBAPP_URL: ""
};

if (url.includes("localhost")) {
    URLConstants = {
      
        BASE_URL: "http://10.10.21.182:8080/WorkMate/web/",
        ATTENDANCE_BASE_URL: "http://10.10.21.182:8081/alapi/",
        ALFRESCO_BASE_URL: "http://10.10.21.182:8080/WorkMate/alfresco/",
        IMAGE_BASE_URL: "http://intouchdev.mapmyindia.com/WorkMate/alfresco/displayImage/",
        BASE_URL_EXPORT: "http://10.10.21.182:8080/WorkMate/exportReport/",
        DOWNLOAD_URL: "http://10.10.21.182:8080/WorkMate/downloadFile/",
        UPLOAD_FILE_URL: "http://10.10.21.182:8080/WorkMate/alfresco/uploadFile",
        COMPANY_IMG_URL: "http://10.10.21.182:8080/WorkMate/",

        LOGIN_URL: "https://outpost.mapmyindia.com/api/security/v4.0.0/oauth/authorize?response_type=token&client_id=n0nUtKKVd58J-I1qzgYMegl_YLSP7XY0&redirect_uri=http://localhost:4200/#/?",
        WEBAPP_URL: "http://localhost:4200/#/"
    }
} else if (url.includes("mappls") && url.includes('pwmnextgen')) {
    URLConstants = {
        BASE_URL: "https://workmate.mappls.com/betaTest/web/",
        ATTENDANCE_BASE_URL: "https://workmate.mappls.com/alapi/",
        ALFRESCO_BASE_URL: "https://workmate.mappls.com/betaTest/alfresco/",
        IMAGE_BASE_URL: "https://workmate.mappls.com/betaTest/alfresco/displayImage/",
        BASE_URL_EXPORT: "https://workmate.mappls.com/betaTest/exportReport/",
        DOWNLOAD_URL: "https://workmate.mappls.com/betaTest/alfresco/downloadFile/",
        UPLOAD_FILE_URL: "https://workmate.mappls.com/betaTest/alfresco/uploadFile",
        COMPANY_IMG_URL: "https://workmate.mappls.com/betaTest/",
        LOGIN_URL: "https://outpost.mappls.com/api/security/v4.0.0/oauth/authorize?response_type=token&client_id=n0nUtKKVd58J-I1qzgYMegl_YLSP7XY0&redirect_uri=https://workmate.mappls.com/pwmnextgen/#/?",
        WEBAPP_URL: "https://workmate.mappls.com/pwmnextgen/#/",
    }
} 
else if (url.includes("mappls")) {
    URLConstants = {

        BASE_URL: "https://workmate.mappls.com/app/web/",
        ATTENDANCE_BASE_URL: "https://workmate.mappls.com/alapi/",
        ALFRESCO_BASE_URL: "https://workmate.mappls.com/app/alfresco/",
        IMAGE_BASE_URL: "https://workmate.mappls.com/app/alfresco/displayImage/",
        BASE_URL_EXPORT: "https://workmate.mappls.com/app/exportReport/",
        DOWNLOAD_URL: "https://workmate.mappls.com/app/alfresco/downloadFile/",
        UPLOAD_FILE_URL: "https://workmate.mappls.com/app/alfresco/uploadFile",
        COMPANY_IMG_URL: "https://workmate.mappls.com/app/",
        LOGIN_URL: "https://outpost.mappls.com/api/security/v4.0.0/oauth/authorize?response_type=token&client_id=n0nUtKKVd58J-I1qzgYMegl_YLSP7XY0&redirect_uri=https://workmate.mapmyindia.com/wmnextgen/#/?",
        WEBAPP_URL: "https://workmate.mappls.com/wmnextgen/#/",

    }

} else if (url.includes("mapmyindia") && url.includes('pwmnextgen')) {

    URLConstants = {

        BASE_URL: "https://workmate.mapmyindia.com/betaTest/web/",
        ATTENDANCE_BASE_URL: "https://workmate.mapmyindia.com/alapi/",
        ALFRESCO_BASE_URL: "https://workmate.mapmyindia.com/betaTest/alfresco/",
        IMAGE_BASE_URL: "https://workmate.mapmyindia.com/betaTest/alfresco/displayImage/",
        BASE_URL_EXPORT: "https://workmate.mapmyindia.com/betaTest/exportReport/",
        DOWNLOAD_URL: "https://workmate.mapmyindia.com/betaTest/alfresco/downloadFile/",
        UPLOAD_FILE_URL: "https://workmate.mapmyindia.com/betaTest/alfresco/uploadFile",
        COMPANY_IMG_URL: "https://workmate.mapmyindia.com/betaTest/",
        LOGIN_URL: "https://outpost.mapmyindia.com/api/security/v4.0.0/oauth/authorize?response_type=token&client_id=n0nUtKKVd58J-I1qzgYMegl_YLSP7XY0&redirect_uri=https://workmate.mapmyindia.com/pwmnextgen/#/?",
        WEBAPP_URL: "https://workmate.mapmyindia.com/pwmnextgen/#/",

    }

} else if (url.includes("intouchdev")) {
    URLConstants = {

        BASE_URL: "https://intouchdev.mapmyindia.com/WorkMate/web/",
        ATTENDANCE_BASE_URL: "https://intouchdev.mapmyindia.com/alapi/",
        ALFRESCO_BASE_URL: "https://intouchdev.mapmyindia.com/WorkMate/alfresco/",
        IMAGE_BASE_URL: "https://intouchdev.mapmyindia.com/WorkMate/alfresco/displayImage/",
        BASE_URL_EXPORT: "https://intouchdev.mapmyindia.com/WorkMate/exportReport/",
        DOWNLOAD_URL: "https://intouchdev.mapmyindia.com/WorkMate/alfresco/downloadFile/",
        UPLOAD_FILE_URL: "https://intouchdev.mapmyindia.com/WorkMate/alfresco/uploadFile",
        COMPANY_IMG_URL: "https://intouchdev.mapmyindia.com/WorkMate/",
        LOGIN_URL: "https://outpost.mapmyindia.com/api/security/v4.0.0/oauth/authorize?response_type=token&client_id=n0nUtKKVd58J-I1qzgYMegl_YLSP7XY0&redirect_uri=http://intouchdev.mapmyindia.com/wmnextgen/#/?",
        WEBAPP_URL: "https://intouchdev.mapmyindia.com/wmnextgen/#/",
    }

} else {
    URLConstants = {

        BASE_URL: "https://workmate.mapmyindia.com/app/web/",
        ATTENDANCE_BASE_URL: "https://workmate.mapmyindia.com/alapi/",
        ALFRESCO_BASE_URL: "https://workmate.mapmyindia.com/app/alfresco/",
        IMAGE_BASE_URL: "https://workmate.mapmyindia.com/app/alfresco/displayImage/",
        BASE_URL_EXPORT: "https://workmate.mapmyindia.com/app/exportReport/",
        DOWNLOAD_URL: "https://workmate.mapmyindia.com/app/alfresco/downloadFile/",
        UPLOAD_FILE_URL: "https://workmate.mapmyindia.com/app/alfresco/uploadFile",
        COMPANY_IMG_URL: "https://workmate.mapmyindia.com/app/",
        LOGIN_URL: "https://outpost.mapmyindia.com/api/security/v4.0.0/oauth/authorize?response_type=token&client_id=n0nUtKKVd58J-I1qzgYMegl_YLSP7XY0&redirect_uri=https://workmate.mapmyindia.com/wmnextgen/#/?",
        WEBAPP_URL: "https://workmate.mapmyindia.com/wmnextgen/#/",

    }
}

export const Constants = {
    // BASE_URL: "http://10.10.21.109:8080/WorkMate/web/",

    BASE_URL: URLConstants.BASE_URL,
    ATTENDANCE_BASE_URL: URLConstants.ATTENDANCE_BASE_URL,
    ALFRESCO_BASE_URL: URLConstants.ALFRESCO_BASE_URL,
    IMAGE_BASE_URL: URLConstants.IMAGE_BASE_URL,
    BASE_URL_EXPORT: URLConstants.BASE_URL_EXPORT,
    DOWNLOAD_URL: URLConstants.DOWNLOAD_URL,
    UPLOAD_FILE_URL: URLConstants.UPLOAD_FILE_URL,
    COMPANY_IMG_URL: URLConstants.COMPANY_IMG_URL,

    LOGIN_URL: URLConstants.LOGIN_URL,
    WEBAPP_URL: URLConstants.WEBAPP_URL,


    DEFAULT_PAGE: {
        PEOPLE: "people",
        CLIENT: "client",
        DASHBOARD: "task",
        REPORT: "report",
        REIMBURSEMENT: "reimburse",
        ADMIN: "manage",
        ATTENDANCE: "attendance",
        FORM: "form"
    },
    IN_APP_OS_TYPE_MAP: {
        ANDROID: "android",
        IOS: "ios"
    },
    KEY: "123456$#@$^@1WRMT",
    STORAGE_KEY: {
        ACCOUNT_INFO: "accountInfo",
        USER_INFO: "userData",
        MANAGER_INFO: "manager",
        FEATURE_MAP: "featureMap",
        LABEL_MAP: "labelMap",
        SELCETED_TASK: "selectedTask",
        SELECTED_FORM_FOR_UPDATE: "selectedFormForUpdate",
        SELECTED_ACTIVITY_FOR_DETAILS: "selectedReimburseActDetail",
        SELECTED_STATUS_CLAIM: "selectedReimburseStatusClaim",
        SELECTED_STATUS_CLAIM_FOR_DETAILS: "selectedReimburseStatusClaimDetails",

        SELECTED_CLAIM_FOR_DETAILS: "selectedReimburseClaimDetail",
        SELECTED_APPROVE_CLAIM: "selectedApproveClaim",
        SELECTED_APPROVE_CLAIM_DETAILS: "selectedApproveClaimDetail",
        SELECTED_WORK_LOCATION: "selectedWorkLocation",
        SELCETED_CLIENT_UPDATE: "selectedClientForUpdate",
        EDIT_ATTENDANCE_PERSON: "editAttendanecPerson",
        SELECTED_LEAVE_TYPE: "selectedLeaveType",
        SELECTED_HOLIDAY: "selectedHoliday",
        SELECTED_WORK_SCHEDULE: "selectedWorkScheedule",
        SELECTED_ATTENDANCE_TYPE: "selectedAttendanceType",
        ON_REQUEST_FORM: "selectedOnRequestForm",
        SELECTED_EXPENSE_TYPE: "selectedExpenseType",
        SELECTED_DESIGNATION: "selectedDesignation",
        NEW_ACCOUNT: "newAccount",
        SELECTED_USER_GROUP: "selectedUserGroup",
        SELECTED_CUSTOM_ASSIGNMENT: "selectedCustomAssignment",
    },
    API_END_POINTS: {
        LOGIN: "login",
        GET_STARTED: "getStarted",
        REQUEST_CALLBACK: "requestCallBack",
        USER_INFO: "userInfo",
        CREATE_ACCOUNT: "createAccount",
        REFRESH_TOKEN: "refreshToken",
        FEEDBACK: "feedback",
        PROFILE_PICTURE: "getProfilePic",
        AUTO_SUGGEST: "autoSuggest",
        PEOPLE_LAST_ACTIVITY: "userLastActivity",
        PEOPLE_STATS: "peopleStats",
        PEOPLE_LIVE_DATA: "getLiveData",
        PEOPLE_UPDATED_DATA: "getUpdatedPeopleDetails",
        PEOPLE_ACTIVITY_DETAIL: "attendanceCheckinDetails",
        PEOPLE_MOVEMENT_DATA: "getDeviceMovementData",
        MOVEMNET_STOPPAGE: "getMovementsStoppage",
        PEOPLE_MOVEMENT_DATA_WITH_ROUTE: "getDeviceMovementDataWithRoute",
        CLIENT_LAST_ACTIVITY: "clientActivity",
        CLIENT_TYPE_LIST: "clientTypeList",
        CLIENT_STATS: "clientStats",
        CLIENT_UPDATED_DETAILS: "getUpdatedClientDetails",
        CLIENT_VISIT_DETAIL: "getVisitDetails",
        REV_GEO_CODE: "revGeoCode",
        REV_GEO_CODE_ALL_ADDR:"revGeoCodeAllAddrress",
        CREATE_CLIENT: "createClient",
        CLIENT_UPLOAD: "uploadPartnerNew",
        DEPARTMENT_UPLOAD: "uploadPartnerDepartment",
        SOS_EVENT_REMARK: "remarkOnSosEvent",
        FETCH_COMPANY_DETAILS: "companyDetails",
        MANAGER_LIST: "managersList",
        USERS_FOR_REPORT: "fetchUserForReport",
        CLIENT_LIST_ACTIVE: "fetchAdminPartnerListActive",
        FORM_LIST: "getFormList",
        UPDATE_BULK_CLIENT: "updateBulkClient",

        PEOPLE_ACTIVITY_REPORT: "fetchActivityReportData",
        CLIENT_ACTIVTIy_REPORT: "fetchPartnerActivityReportData",
        ATTENDANCE_REPORT: "fetchAttendanceReportData",
        TASK_REPORT: "fetchTaskReportData",
        SOS_REMARK_REPORT: "getSosRemarkReportData",
        PRODUCTIVITY_REPORT: "productivityReportNew",
        FORMS_REPORT: "formsReport",
        REIMBURSEMENT_REPORT: "getReimbursementReport",
        SCHEDULE_REPORT_LIST: "shceduleReportList",
        CREATE_SCHEDULE_REPORT_CONFIG: "createScheduleReportConfig",
        UPDATE_SCHEDULE_REPORT_CONFIG: "updateScheduleReportConfig",
        DELETE_SCHEDULE_REPORT_CONFIG: "deleteScheduleReportConfig",
        CHANGE_CONFIG_REPORT_STATUS: "changeConfigReportStatus",
        DOWNLOAD_CLIENT_UPLOAD_SAMPLE: "downloadClientSampleFile",
        DOWNLOAD_DEPARTMENT_UPLOAD_SAMPLE: "downloadClientDepartmentSampleFile",
        DOWNLOAD_CLIENT_UPDATE_SAMPLE: "downloadUpdateClientSampleFile",

        WORKPLACE_LIST: "workplace",
        JOBS_LIST: "jobsList",
        FETCH_JOBS_DATA: "fetchjobsdataNew",
        FIELD_USER_LIST: "fieldUserList",
        SAVE_TASK_LIST: "saveJob",
        UPDATE_TASK_LIST: "updateJob",
        GET_SKILLS: "getSkills",
        PARTNER_LIST: "partnerList",
        SAVE_TASK: "savetask",
        MANUAL_TASK_CLOSE: "manualclose",
        TASK_COMMENT: "comment",
        UPDATE_TASK_DESC: "updateTaskDescription",
        USER_DAY_ACTIVITY: "userDayActivity",
        CLIENT_DAY_ACTIVITY: "clientDayActivity",
        CHECKIN_DETAILS_BY_ID: "checkinDetailsById",
        CREATE_CUSTOMFORM: "createForm",
        UPDATE_CUSTOMFORM: "updateForm",
        DELETE_CUSTOMFORM: "formDelete",
        GET_ASSIGNED_USER_FORM_DETAILS: "formUserActivity",
        SET_ASSIGNED_USER_FORM_DETAILS: "formUserActivity",



        FETCH_ATTENDANCE_ACTIVITIES: "fetchAttendanceActivities",
        MOVE_ACTIVITIES_TO_REIMBURSE: "moveActivitiesToReimburse",
        UPDATE_CLAIMED_DISTANCE: "updateClaimedDistance",
        GET_ALL_CLAILMS: "getAllClaims",
        MOVE_TO_SAVE_FOR_LATER: "moveToSaveForLater",
        MOVE_TO_CLAIM: "moveToClaim",
        REMOVE_CLAIM: "removeClaim",
        ADD_NEW_CLAIM: "addNewClaim",
        UPDATE_CLAIM: "updateClaim",
        CLAIM_APPROVAL: "claimApproval",
        NEW_CLAIMED_DISTANCE: "newClaimedDistance",
        GET_CLAIM_APPROVAL: "getMyClaimApproval",
        GET_DATA_ON_CLAIM_IDS: "getDataOnClaimIds",
        SEND_REMINDER_FOR_APRROVAL: "sendReminderForApproval",
        EXPORT_CLAIMS_DETAIL_REPORT: "exportClaimsDetailReport",
        GET_ALL_CLAIM_APPROVAL: "getAllClaimApproval",
        UPDATE_CLAIM_STATUS: "updateClaimStatus",
        UPDATE_APPROVAL_CLAIMED_DISTANCE: "updateApprovalClaimedDistance",
        SEND_FOR_REIMBURSEMENT: "sendForReimbursement",
        UPDATE_APPROVED_AMOUNT: "updateApprovedAmount",
        ACTIVITY_DETAILS: "activityDetails",
        UPDATE_TRAVEL_COST: "updateTravelCost",
        NEW_CLAIMED_AMOUNT: "newClaimedAmount",

        ACTIVITY_CUSTOM_FORM_DATA: "activityCustomFormData",
        USER_ACTIVITY_FORMS: "getUserActivityForms",
        GET_FORMS_ACTIVITY_REPORT: "getActivityFormsReport",

        CLIENT_CATEGORY: "clientCategory", // used for create , get and delete
        UPDATE_CLIENT_CATEGORY: "updateClientCategory",
        CLIENT_TAG: "clientTag",// used for create ,get and delete
        UPDATE_CLIENT_TAG: "updateClientTag",
        REMARK_TEMPLATE: "remarkTemplate", // used for create , get and delete
        UPDATE_REMARK_TEMPLATE: "updateRemarkTemplate ",
        GET_EXPENSE_TYPE: "getExpenseType",
        ADD_EXPENSE_TYPE: "expenseType",
        UPDATE_EXPENSE_TYPE: "updateExpenseType",
        CREATE_SKILL: "skill",
        UPDATE_SKILL: "updateSkill",
        EMERGENCY_CONTACT: "emergencyContact",
        UPDATE_EMERGENCY_CONTACT: "updateEmergencyContact",
        GET_USER_LIST: "userList ",
        OFFICE_TYPE: "officeType", /// usd for create ,get and delete
        UPDATE_OFFICE_TYPE: "updateOfficeType",
        NULL_CLIENT_COUNT: "nullClientCount",
        COMPANY_IMAGE: "companyImage",
        UPDATE_WORKPLACE: "updateWorkplace",
        EXPORT_CLIENTS_WITHOUT_LOCATION_REPORT: "exportClientsWithoutLocationReport",
        GET_CLIENT_LIST: "clientList",
        UPDATE_CLIENT: "updateClient",
        ADD_USER: "addUser",
        IS_USER_ROLE_CHANGE: "isUserRoleChange",
        UPDATE_USER: "updateUser",
        DEACTIVATE_USER: "deactivateUser",
        DELETE_USER: "deleteUser",
        RESEND_LINK_FOR_INVITE_USER: "resendLink",
        STATUS_CLAIM_REPORT: "exportStatusClaim",
        ACTIVITIES_TYPE: "typeMaster",
        BULK_UPLOAD_USER: "uploadBulkUser",
        DESIGNATION: "designation",
        GET_DESIGNATION: "getdesignation",
        UPDATE_DESIGNATION: "updateDesignation",


        //attendance apis

        ATTENDANCE: "attendance",
        LEAVE: "leave",
        LEAVE_TYPE: "leaveType",
        TEAM_ATTENDANCE: "teamAttendance",
        ATTENDANCE_APPROVAL: "attendanceApproval",
        LEAVE_SUMMARY: "leaveSummary",
        LEAVE_APPROVAL: "leaveApproval",
        HOLIDAY: "holiday",
        ATTENDANCE_TYPE: "attendanceTypes",
        SAVE_ATTENDANCE_TYPE: "attendanceType",
        ATTENDANCE_TYPE_MASTER: "typeMaster",
        ATTENDNACE_REMARK: "remark",
        ATTENDANCE_SUMMARY: "attendanceSummary",
        ATTENDANCE_DETAIL_SUMMARY_REPORT: "attendanceDetailSummary",
        ATTENDANCE_DETAILS_REPORT: "attendanceDetailsReport",
        WORK_SCHEDULE: "shift",
        PLAN_SUMMARY: "planSummaryReport",

        DOWNLOAD_USER_UPLOAD_SAMPLE: "downloadUserSampleFile",

        //Multiple Account 
        GET_USER_ACCOUNTS: "user-accounts",
        DEFAULT_USER_ACCOUNT: "user-default-account",

        //USER GROUP 
        USER_GROUP: "userGroups",

        BULK_UPLOAD_USER_With_PASSWORD: "uploadBulkUserForSpecificAdmin",
        DOWNLOAD_USER_UPLOAD_SAMPLE_PASSWORD: "downloadUserSampleFileSpecificAdmin",

        DOWNLOAD_TASK_SAMPLE: "downloadTaskSampleFile",
        TASK_UPLOAD: "uploadBulkTask",
        USER_ATTENDANCE_FOR_TODAY: "todayUserAttendance",

        ACTIVITY_CUSTOM_FORM_DATA_FOR_ONREQUEST: "activityCustomFormDataForOnRequest",

        FIELD_USER_LIST_BY_CLIENT: "fieldUserListByClient",
        GEO_ANALYTICS_LISTING : "listingapi",
        DOWNLOAD_PLAN_UPLOAD_SAMPLE: "downloadPlanSampleFile",
        BULK_UPLOAD_PLAN: "uploadBulkPlan",

        TRAVEL_REPORT:"travelModeReportData",
        MANUAL_CLOSER_TASK_UPLOAD: "bulkTasksManualCloser", 
       

    },
    ALFRESCO_ENDPOINT: {
        FILE_LIST: "getFileList",
        DELETE_FILE: "deleteFile",
        DOWNLOAD_FILE: "downloadFile",
        UPLOAD_FILE: "uploadFile",
        DISPLAY_IMG: "displayImage"
    },
    EXPORT_REPORT_URL: {
        PEOPLE_ACTIVITY_REPORT: "exportPeopleActivity",
        SOS_REMARK_REPORT: "exportSOSReport",
        MOVEMENT_REPORT: "exportMovementReport",
        CLIENT_ACTIVITY_REPORT: "exportClientActivity",
        ATTENDANCE_REPORT: "exportAttendanceReport",
        TASK_REPORT: "exportTaskReport",
        PRODUCTIVITY_REPORT: "exportProductivity",
        FORMS_REPORT: "exportForms",
        FORMS_ACTIVITY_REPORT: "exportActivityForms",
        REIMBURSEMENT_REPORT: "exportReimbursement",
        ATENDANCE_DETAILS: "exportReport/exportAttendnaceDetailsReport",
        ATTENDANCE_SUMMARY: "exportReport/exportAttendanceSummaryReport",
        PLAN_SUMMARY: "exportPlanSummaryReport",
        ATTENDANCE_DETAIL_SUMMARY: "exportReport/exportAttendanceDetailSummaryReport",
        MOVEMENT_STOPPAGE_REPORT: "exportMovementStoppageReport",
        TRAVEL_REPORT: "exportTravelReport",
        DOWNLOAD_TASK_FOR_MANUAL_CLOSER : "exportTaskForManualClose"


    },
    INFO_POPUP_IMAGE: 'assets/img/info.png',
    SUCCESS_POPUP_IMAGE: 'assets/img/success.png',
    ERROR_POPUP_IMAGE: 'assets/img/error.png',

    HTTP_STATUS: {
        OK: 200,
        UNAUTHORIZED: 401
    },
    FEEDBACK_TYPE_LIST: [
        { key: "BUG", text: "I found a bug", str: "BUG" },
        { key: "TASK", text: "I have a suggestion", str: "TASK" },
        { key: "STORY", text: "General Feedback", str: "STORY" },
        { key: "BUG1", text: "Other Issues", str: "BUG" }
    ],

    LABEL_MAP: {
        PEOPLE: { id: 1, defaultLabel: "Employee" },
        CLIENT: { id: 2, defaultLabel: "Client" },
        DASHBOARD_TASK: { id: 3, defaultLabel: "Task" },
        REPORTS: { id: 4, defaultLabel: "Reports" },
        MANAGE: { id: 5, defaultLabel: "Manage" },
        DASHBOARD: { id: 7, defaultLabel: "Task" },
        CHECK_IN: { id: 8, defaultLabel: "Checked-In" },
        CHECK_OUT: { id: 9, defaultLabel: "Checked-Out" },
        TASK_CHECK_IN: { id: 12, defaultLabel: "Task Checked-In" },
        TASK_CHECK_OUT: { id: 13, defaultLabel: "Task Checked-Out" },
        WORK_START: { id: 10, defaultLabel: "Work Start" },
        WORK_END: { id: 11, defaultLabel: "Work End" }
    },

    FEATURE_MAP: {
        DASHBOARD_PAGE: 6,
        UNIQUE_ID_BASED_ACCESS: 13,
        PEOPLE_PAGE: 14,
        CLIENT_PAGE: 15,
        CREATE_CLIENT: 16,
        UPLOAD_CLIENT: 17,
        UPDATE_CLIENT: 18,
        UPLOAD_DEPARTMENT: 19,

        CREATE_TASK: 20,
        CREATE_TASK_LIST: 21,

        REPORT_PAGE: 22,
        ACTIVITY_PEOPLE_REPORT: 23,
        ACTIVITY_CLIENT_REPORT: 24,
        ATTENDANCE_REPORT: 25,
        MOVEMENT_REPORT: 26,
        TASK_REPORT: 27,

        MANAGE_PAGE: 28,
        USER_LIST: 29,
        FORM_BUILDER: 30,
        CLIENT_LIST: 31,
        TAGS_AND_CATEGORIES: 32,
        REMARK_TEMPLATE: 33,
        EMERGENCE_CONTACT_DETAILS: 34,
        SKILL_SET: 35,
        COMPANY_SETTINGS: 36,
        BEACON_FREQUENCY: 37,
        COST_FACTOR: 38,
        AUTO_WORK_END: 39,
        CLIENT_VIEW_RIGHT: 40,
        CHECK_IN_BOUNDARY: 42,
        WORK_PLACE_BOUNDARY: 43,
        DISTANCE_USING_ROUTE: 55,
        REIMBURSEMENT: 56,
        ATTENDANCE_LEAVE_MANAGEMENT: 58,
        AUTO_TRACKING: 57,
        TRAVEL_START_END :64, //dummy

    },
    IMAGE_EXTENTION_LIST: ["jpg", "jpeg", "png", "gif"],

    RANDOM_COLOR_CLASS: ["lorange", "lpurple", "lgreen", "lgrey", "lred", "lblue", "lyellow"],

    FORM_ACTIVTY_TYPE: [1, 2, 3, 4, 5],

    FORM_ACTIVTY_MAP: {
        WORK_START: 1,
        WORK_END: 2,
        CHECK_IN: 3,
        CHECK_OUT: 4,
        CLIENT_CREATED: 5,
        ON_DEMAND: 6
    },

    CLAIM_STATUS: {
        CLAIM_STATUS_SYSTEM_APPROVED: 4,
        CLAIM_STATUS_PARTIALLY_APPROVED: 5,
        CLAIM_STATUS_APPROVED: 6,
        CLAIM_STATUS_APPROVAL_PENDING: 3,
        CLAIM_STATUS_REJECTED: 7,
    },
    STATUS_FILTER_LIST:
    {
        // 0:"No Filter",
        3: { key: 3, name: "Approval Pending", bool: true },
        6: { key: 6, name: "Approved", bool: false },
        7: { key: 7, name: "Rejected", bool: false },
        //            4:"System Approved",
        5: { key: 5, name: "Partially Approved", bool: false }
    },

    ALL_EXCEPTIONAL_FILTER_LIST:
        [
            'All',
            'Exceptional'

        ],

    USER_TYPE: {
        ADMIN: 0,
        MANAGER: 1,
        FIELD_USER: 2
    },

    LANDING_PAGE: {
        WELCOME: "welcome",
        HOME: "home",
        FIELD_USER: "field-user",
        GET_STARTED: "get-started",
        ACCOUNT_CREATION: "account-creation"
    },
    ATTENDANCE_TYPE:{
        WORK_START_END :1,
        CHECKIN_OUT :2,
        TRAVEL_START_END :3,
     },

}
